var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", "px-4": "", "py-2": "" } },
        [
          _c(
            "v-form",
            {
              ref: "form",
              model: {
                value: _vm.formValid,
                callback: function ($$v) {
                  _vm.formValid = $$v
                },
                expression: "formValid",
              },
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Input an Analyte Name",
                  placeholder: "Chloride (Cl)-Dissolved",
                  rules: _vm.analyteNameRules,
                },
                model: {
                  value: _vm.analyteName,
                  callback: function ($$v) {
                    _vm.analyteName = $$v
                  },
                  expression: "analyteName",
                },
              }),
              _vm._v(" "),
              _c("v-combobox", {
                attrs: {
                  items: _vm.commonUnitGroups,
                  label: "Select a Unit Group or specify one",
                  rules: _vm.unitGroupRules,
                },
                model: {
                  value: _vm.unitGroup,
                  callback: function ($$v) {
                    _vm.unitGroup = $$v
                  },
                  expression: "unitGroup",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", "pb-3": "" } },
        [
          _c(
            "v-alert",
            {
              staticStyle: { padding: "8px" },
              attrs: {
                type: _vm.formValid ? "success" : "info",
                value: _vm.hasInput,
                outline: "",
                transition: "slide-y-transition",
              },
            },
            [
              _vm.formValid
                ? [
                    _vm._v("\n        EnviroData Analyte Name: "),
                    _c(
                      "span",
                      { staticClass: "font-weight-bold font-italic" },
                      [_vm._v(_vm._s(_vm.envirodataAnalyteName))]
                    ),
                  ]
                : [_vm._v("\n        Please complete all form fields\n      ")],
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "warning", small: "" },
              on: { click: _vm.reset },
            },
            [_vm._v("Reset")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }